export default __webpack_public_path__ + "static/media/home.eee23d83.svg";